/** Equity option OCC: ROOT + YYMMDD + C/P + strike×1000. */
export function looksLikeOccOptionSymbol(symbol) {
  return /^[A-Z]{1,6}\d{6}[CP]\d{8}$/.test(
    String(symbol || '').trim().toUpperCase().replace(/\s+/g, '')
  );
}

/**
 * Contract point value. Explicit multiplier wins; OCC options default to 100
 * even when the API omitted it (otherwise % is 100× too large).
 */
export function tradePointValue(multiplier, symbol) {
  const n = Number(multiplier);
  if (Number.isFinite(n) && n > 0) return n;
  if (looksLikeOccOptionSymbol(symbol)) return 100;
  return 1;
}

/**
 * Return on notional: pnl / (entry × qty × point value).
 * Futures and options dollar P&L already include the multiplier, so the basis must too.
 */
export function computeTradePnlPercent(trade) {
  if (trade?.pnl == null || trade.entryPrice == null || !trade.quantity) return null;
  const basis = Math.abs(
    Number(trade.entryPrice)
    * Number(trade.quantity)
    * tradePointValue(trade.multiplier, trade.symbol)
  );
  if (!basis) return null;
  return (Number(trade.pnl) / basis) * 100;
}
